import { render, staticRenderFns } from "./EmbeddedMedia.vue?vue&type=template&id=a59c84de&"
import script from "./EmbeddedMedia.vue?vue&type=script&lang=js&"
export * from "./EmbeddedMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports